export default {"src":"/_next/static/media/google-play-button.9e65e121.svg","height":62,"width":208,"blurWidth":0,"blurHeight":0};